/**
 * EAA-1701 (A5.3): real Content Bank metrics for the launcher card.
 *
 * The launcher shows a LIVE program count on the Content Studio (ACH) card,
 * fetched with the user's RS256 token + the active tenant — proving the portal
 * reads real data through the SSO token (Phase A exit criterion), not a stub.
 * ACH's program list is the standard paginated envelope, so `data.count` is the
 * total; we request `page_size=1` to keep it cheap (we only need the count).
 *
 * The portal is a standalone app (no monorepo `shared-api`), so this is a plain
 * token-authenticated fetch — the card owns its own query and fails soft, so a
 * slow/down ACH degrades ONLY this card (never the whole launcher).
 */

import { authFetch } from './authFetch';
export async function fetchProgramCount(
    achApiBase: string,
    token: string,
    tenantId?: string | null
): Promise<number> {
    const headers: Record<string, string> = {};
    if (tenantId) {
        headers['X-Tenant-Id'] = tenantId;
    }
    // EAA-1825: `authFetch` retries once with a renewed token on 401.
    const res = await authFetch(`${achApiBase}/api/v1/program/programs/list/?page_size=1`, token, { headers });
    if (!res.ok) {
        throw new Error(`Content Bank program count failed (${res.status})`);
    }
    const envelope = (await res.json()) as { data?: { count?: number } };
    return envelope.data?.count ?? 0;
}
